/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Statut d'ancienneté du locataire au début du contrat GLI : 0 = nouveau (moins de 16 jours, dossier revenus exigé), 1 = refusé (entre 16 jours et 6 mois, zone anti-sélection), 2 = en place (plus de 6 mois, seule la déclaration « à jour de ses loyers » est exigée), 3 = entrée future (plus de 6 mois après le début du contrat, à souscrire ultérieurement).
 * 
 * @export
 */
export const TenantSeniorityStatusEnum = {
    New: 0,
    RefusedPeriod: 1,
    InPlace: 2,
    FutureEntry: 3
} as const;
export type TenantSeniorityStatusEnum = typeof TenantSeniorityStatusEnum[keyof typeof TenantSeniorityStatusEnum];


export function instanceOfTenantSeniorityStatusEnum(value: any): boolean {
    for (const key in TenantSeniorityStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(TenantSeniorityStatusEnum, key)) {
            if (TenantSeniorityStatusEnum[key as keyof typeof TenantSeniorityStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TenantSeniorityStatusEnumFromJSON(json: any): TenantSeniorityStatusEnum {
    return TenantSeniorityStatusEnumFromJSONTyped(json, false);
}

export function TenantSeniorityStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantSeniorityStatusEnum {
    return json as TenantSeniorityStatusEnum;
}

export function TenantSeniorityStatusEnumToJSON(value?: TenantSeniorityStatusEnum | null): any {
    return value as any;
}

export function TenantSeniorityStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): TenantSeniorityStatusEnum {
    return value as TenantSeniorityStatusEnum;
}

